import React from 'react'

import { PlatformForImprovingDiagnosticAccuracy } from '@components/cases/PlatformForImprovingDiagnosticAccuracy'
import { CustomHead } from '@ui/sections/CustomHead'

function AIPoweredPlatformForPatientDiagnosing() {
  return (
    <>
      <CustomHead
        title="AI-powered platform for patient diagnosing."
        description="Looking for a dedicated team of engineers skilled in crafting AI-powered MedTech solutions? Dive into our recent case study and search no more."
        imagePath="/images/custom-head/newcustom-head-platform-for-improving-diagnostic.webp"
      />
      <PlatformForImprovingDiagnosticAccuracy />
    </>
  )
}

export default AIPoweredPlatformForPatientDiagnosing
